module.exports = __webpack_public_path__ + "static/media/400059_02.063f18ea.png";